import { render, staticRenderFns } from "./QuizAnswerResult.vue?vue&type=template&id=7d90db50&scoped=true&"
import script from "./QuizAnswerResult.vue?vue&type=script&lang=js&"
export * from "./QuizAnswerResult.vue?vue&type=script&lang=js&"
import style0 from "./QuizAnswerResult.vue?vue&type=style&index=0&id=7d90db50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d90db50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
